// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountPhoneModel {
    static getAttributeTypeMap() {
        return AccountPhoneModel.attributeTypeMap;
    }
}
AccountPhoneModel.discriminator = undefined;
AccountPhoneModel.additionalProperties = false;
AccountPhoneModel.attributeTypeMap = [
    {
        "name": "phoneId",
        "baseName": "phoneId",
        "type": "number"
    },
    {
        "name": "phoneType",
        "baseName": "phoneType",
        "type": "AccountPhoneContactInformationType"
    },
    {
        "name": "phonePurpose",
        "baseName": "phonePurpose",
        "type": "AccountContactInformationPurposeType"
    },
    {
        "name": "phoneNumber",
        "baseName": "phoneNumber",
        "type": "string"
    },
    {
        "name": "extension",
        "baseName": "extension",
        "type": "string"
    },
    {
        "name": "isVoicemailOptedIn",
        "baseName": "isVoicemailOptedIn",
        "type": "boolean"
    },
    {
        "name": "isPrimary",
        "baseName": "isPrimary",
        "type": "boolean"
    },
];
//# sourceMappingURL=accountPhoneModel.js.map